import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const LanguageSwitcher = () => {
  const location = useLocation(); // Detectar cambios de ruta
  const [lang, setLang] = useState(localStorage.getItem("gt_forced_lang") || "es");

  // ✅ Cargar GTranslate correctamente
  const loadGTranslateScript = () => {
    return new Promise((resolve) => {
      // 🔥 Eliminar scripts previos si existen
      document.querySelectorAll("script[src='https://cdn.gtranslate.net/widgets/latest/dwf.js']").forEach(script => script.remove());

      // 🔥 Crear nuevo script
      const script = document.createElement("script");
      script.src = "https://cdn.gtranslate.net/widgets/latest/dwf.js";
      script.defer = true;

      script.onload = () => {
        if (window.gtranslate) {
          window.gtranslate.translate(lang); // Aplicar el idioma seleccionado
          resolve();
        }
      };

      document.body.appendChild(script);
    });
  };

  // ✅ Configurar GTranslate cada vez que se monta el componente o cambia de ruta
  useEffect(() => {
    document.documentElement.lang = lang;

    window.gtranslateSettings = {
      default_language: lang,
      native_language_names: true,
      detect_browser_language: false,
      languages: ["es", "en"],
      wrapper_selector: ".gtranslate_wrapper",
      flag_size: 24,
      switcher_open_direction: "top",
      flag_style: "3d",
      alt_flags: { en: "usa", es: "colombia" },
      switcher_text_color: "#f7f7f7",
      switcher_arrow_color: "#f2f2f2",
      switcher_border_color: "#005C59",
      switcher_background_color: "#005C59",
      switcher_background_shadow_color: "#005C59",
      switcher_background_hover_color: "#005C59",
      dropdown_text_color: "#eaeaea",
      dropdown_hover_color: "#748393",
      dropdown_background_color: "#474747",
      cookie_name: "forced_es_lang"
    };

    // ✅ Cargar script de GTranslate
    loadGTranslateScript();
  }, [location.pathname]); // Se ejecuta al cambiar de ruta

  // ✅ Función para cambiar el idioma
  const handleLanguageChange = (selectedLang) => {
    if (lang !== selectedLang) {
      setLang(selectedLang);
      localStorage.setItem("gt_forced_lang", selectedLang);

      // 🔥 Forzar la recarga del widget para aplicar el cambio
      loadGTranslateScript();
    }
  };

  return (
    <div className="gtranslate_wrapper" style={{ position: "relative" }}>
      <button className="hidden" onClick={() => handleLanguageChange("es")} disabled={lang === "es"}>
        {lang === "es" ? "Español ✅" : "Español"}
      </button>
      <button className="hidden" onClick={() => handleLanguageChange("en")} disabled={lang === "en"}>
        {lang === "en" ? "English ✅" : "English"}
      </button>
    </div>
  );
};

export default LanguageSwitcher;
